import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";
import { CompanyList } from "../pages/entreprises/CompanyList";
import { CircularProgress, Box } from "@mui/material";

export const CompanyRedirect: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const shouldRedirectToOwnCompany =
    !!user?.entrepriseId &&
    (user?.role === "MODERATOR" ||
      user?.role === "MODERATOR_FREE" ||
      user?.role === "VIGILANE" ||
      user?.role === "OPERATOR");

  useEffect(() => {
    // Roles scope entreprise unique: redirection directe vers leur entreprise
    if (shouldRedirectToOwnCompany) {
      navigate(`/company/${user.entrepriseId}`, { replace: true });
    }
  }, [user, navigate, shouldRedirectToOwnCompany]);

  // Afficher un loader pendant la redirection
  if (shouldRedirectToOwnCompany) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Sinon, afficher la liste normale des entreprises
  return <CompanyList />;
};
